import { Component, inject, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { AddressEdit } from "../Controlls/AddressEdit"
import { DateSelect } from "../Controlls/DateSelect"
import { Notfallplan } from '../../Api/DcoApi/Notfallplan';
import { RestClient } from '../../Api/DcoApi/Client/RestClient';
import { Kontackt } from '../../Api/DcoApi/Kontackt';
import { Address } from '../../Api/DcoApi/Address';
import { GeschlechtsAuswahl } from '../Controlls/GeschlechtsAuswahl';
import { Dictionary } from '../../Api/DcoApi/Dictionary';
import {IsSpezialUserDirective, IsVolleBerechtigung, IsWelcomeCallDirective} from '../../Admin/AdminGuard';
import {Phonenumber} from '../../Directives/Phonenumber';

@Component({
  imports: [
    FormsModule, AddressEdit, DateSelect, GeschlechtsAuswahl, IsWelcomeCallDirective, IsSpezialUserDirective,Phonenumber,IsVolleBerechtigung
  ],
  selector: 'KontaktEdit',
  templateUrl: './KontacktEdit.html',
  standalone: true,
  styleUrl: './KontacktEdit.css'
})
export class KontaktEdit implements OnChanges {
  constructor(private cdr: ChangeDetectorRef) { }
    ngOnChanges(changes: SimpleChanges): void {
      this.LoadPlan();
    }
  ngOnInit(): void {
    this.LoadPlan();
  }
  modal = inject(NgbActiveModal);
  Kontakte: Kontackt[] | null = null;
  EditKontakte: Kontackt | null = null;
  Client: RestClient = new RestClient();

  async LoadPlan() {
    this.Kontakte = (await this.Client.Get<Kontackt[]>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakte`) ?? {} as Kontackt[]).sort((a, b) => a.order - b.order);
    this.cdr.detectChanges();
  }

  async changeOrder(Kontackt:Kontackt, pos: number){
    Kontackt.order = pos;
    try {
      await this.Client.Put(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakt/${Kontackt.key}/Order`, Kontackt);
    }
    catch (error) {
    }

    await this.LoadPlan();
  }
  addNew() {
    this.EditKontakte = { key: 0 } as Kontackt;
  }
  selectKontakt(item: Kontackt) {
    this.EditKontakte = item;
  }

  addressString(item: Kontackt): string {

    var address = item.adressen[0] ?? new Address();

    return `${address.strasse} ${address.hausnummer} ${address.plz} ${address.ort}`;
  }

  async DeleteKontakt(key: number) {
    await this.Client.Delete(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakt/${key}/Delete`);
    await this.LoadPlan();
  }

  get SchluesselVorhanden(): string | null {
    var kontakt = this.EditKontakte as Kontackt;
    if (!this.EditKontakte || this.EditKontakte == null || !kontakt.zusatzInfos) {
      return null;
    }

    var dict = kontakt.zusatzInfos as Dictionary<string, string>;

    if (!dict || !dict["SchluesselVorhanden"]) {
      return null;
    }

    return dict["SchluesselVorhanden"];
  }
  set SchluesselVorhanden(vor: string) {
    var kontakt = this.EditKontakte as Kontackt;
    if (!this.EditKontakte || this.EditKontakte == null ) {
      return;
    }

    try {
      if (!kontakt.zusatzInfos || kontakt.zusatzInfos == null)
        kontakt.zusatzInfos = {}


      var dict = kontakt.zusatzInfos as Dictionary<string, string>;

      if (!dict) {
        kontakt.zusatzInfos = {};
      }
      dict["SchluesselVorhanden"] = vor;
    } catch (ex) {
      console.log(ex);
    }
  }

  get Fahrzeit(): string | null {
    var kontakt = this.EditKontakte as Kontackt;
    if (!this.EditKontakte || this.EditKontakte == null || !kontakt.zusatzInfos) {
      return null;
    }

    var dict = kontakt.zusatzInfos as Dictionary<string, string>;

    if (!dict || !dict["Fahrzeit"]) {
      return null;
    }

    return dict["Fahrzeit"];
  }
  set Fahrzeit(vor: string) {
    var kontakt = this.EditKontakte as Kontackt;
    if (!this.EditKontakte || this.EditKontakte == null) {
      return;
    }

    try {
      if (!kontakt.zusatzInfos || kontakt.zusatzInfos == null)
        kontakt.zusatzInfos = {}


      var dict = kontakt.zusatzInfos as Dictionary<string, string>;

      if (!dict) {
        kontakt.zusatzInfos = {};
      }
      dict["Fahrzeit"] = `${vor}`;
    } catch (ex) {
      console.log(ex);
    }
  }

  async SaveKontackt() {
    if (this.EditKontakte != null) {
      if (this.EditKontakte.key == 0) {
        this.Kontakte?.push(await this.Client.Post<Kontackt, Kontackt>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakt/Create`, this.EditKontakte));
      }
      else {
        await this.Client.Put<Kontackt, Kontackt>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Kontakt/Update`, this.EditKontakte);
      }
      this.EditKontakte = null;
    }

    this.cdr.detectChanges();
  }

  get adresse(): Address | null {
    if (this.EditKontakte == undefined)
      return null;

    if (this.EditKontakte.adressen == undefined)
      this.EditKontakte.adressen = [];

    if (this.EditKontakte.adressen.length == 0)
      return null;

    return this.EditKontakte?.adressen[0] ?? null
  }
  set adresse(addresse: Address | null) {
    if (this.EditKontakte != null) {
      if (this.EditKontakte.adressen == undefined || this.EditKontakte.adressen == null) {
        this.EditKontakte.adressen = [];
      }

      if (addresse != null) {


        if (this.EditKontakte.adressen?.length > 0) {
          this.EditKontakte.adressen[0] = addresse;
        }
        else
          this.EditKontakte.adressen.push(addresse)
      }
      else {
        this.EditKontakte.adressen = [];
      }
    }
  }


  @Input() VersichertenNR: string | null = null;
}
